import { Formik, Field } from "formik";
import React, { useState, useRef, useContext, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  manageMapperFormNames,
  mapperFormFields,
  FLOW_TYPES,
  ROUTES,
  yesNoOptions,
  sourceTypeData,
  fileFormatData,
  required,
  returnOnlyIfBoolean,
  stringToFunctionConverter,
  PassthorughTargetfileFormatData,
} from "../../../utils";
import {
  ManageMapperLayout,
  FieldDropSide,
  SearchableList,
  FieldInput,
  FieldButtonGroup,
  FieldInputPassword,
  LoaderWrapper,
  EncryptionDetails,
  FTPDetails,
  FileNameDropSide,
  FieldInputNumber,
  UploadComponent,
  AddToolTip,
} from "../../../components";
import FixedWidthSwitchComponent from "../../../components/FixedWidthSwitchComponent";
import { onSaveOutputTarget, onSavePassthroughTarget } from "../../../services";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  MANAGE_MAPPER_POST_API_ERROR,
  setMapperPostResponse,
  setOldFileName,
  UploadTargetFile,
  setFileUploadData,
} from "../../../contexts";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { get, isEmpty } from "lodash";
import * as Yup from "yup";
import { Button } from "react-bootstrap";
import ConfigureFileSlider from "../MapAndTransformOutput/ConfigureFileSlider";
import {
  fileMetaOption,
  fileNameOptions,
} from "./../../../utils/constants/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import {
  PassthorughfileFormatData,
  fileMetaData,
  jsonToStringConverter,
  passthroughFileMetaData,
} from "./../../../utils/constants/mapper";
const isValidSheetNumber = /^\d{1,15}$/;
const iscontentstartsfrom = /^\d{1,7}$/;
const OutputTargetContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId, mapType } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT || profileId;
  const formName = manageMapperFormNames.OUTPUT_TARGET;
  const fields = mapperFormFields[formName];
  const targetFileMetaData =
    mapType == 3 ? passthroughFileMetaData : fileMetaData;
  const data = get(state, "api.data", {});
  const ftpDetails =
    mapType == 3
      ? get(state, "api.data.redirectFTP", {})
      : get(state, "api.data.ftpChannel", {});
  const fileNameFromApi =
    mapType == 3 ? get(data, "targetFileName", "") : get(data, "fileName", "");
  const fileNameFromApiRes = fileNameFromApi?.startsWith("'")
    ? fileNameFromApi?.slice(1, fileNameFromApi.length - 1)
    : fileNameFromApi?.startsWith("@")
    ? targetFileMetaData.find(
        (item) =>
          item.propertyName == fileNameFromApi?.slice(1, fileNameFromApi.length)
      )?.propertyName
    : fileNameFromApi?.slice(0, fileNameFromApi.length);
  const fileOption =
    fileNameFromApi?.startsWith("'") || isEmpty(fileNameFromApi)
      ? 1
      : fileNameFromApi?.startsWith("@")
      ? 2
      : 3;
  let DefaultNameFromApiRes = null;
    const DefaultHeaderNameFromApi = get(data, "defaultHeaderName", "");
    if(DefaultHeaderNameFromApi != null){
    DefaultNameFromApiRes = DefaultHeaderNameFromApi?.startsWith("'")
        ? DefaultHeaderNameFromApi?.slice(1, DefaultHeaderNameFromApi.length - 1)
        : DefaultHeaderNameFromApi?.startsWith("@")
        ? targetFileMetaData.find(
            (item) =>
              item.propertyName == DefaultHeaderNameFromApi?.slice(1, DefaultHeaderNameFromApi.length)
          )?.propertyName
        : DefaultHeaderNameFromApi?.slice(0, DefaultHeaderNameFromApi.length);
  }
    
  const [requireFTP, setRequireFTP] = useState(true);
  const [dataLoading, setDataLoading] = useState(false);
  const [slideShow, setSlideShow] = useState(false);
  const [saveData, setSaveData] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  const [configureValue, setConfigureValue] = useState();

  const [dataLoading1, setDataLoading1] = useState(false);
  const [slideShow1, setSlideShow1] = useState(false);
  const [saveData1, setSaveData1] = useState([]);
  const [mappedData1, setMappedData1] = useState([]);
  const [configureValue1, setConfigureValue1] = useState();
  const [checkSubmit1, setCheckSubmit1] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newFile, setNewFile] = useState([]);
  const [previousFile, setPreviousFile] = useState("");
  const [clearField, setClearField] = useState(false);
  const [showFileName, setShowFileName] = useState(true);
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [fileUploadRequired, setFileUploadRequired] = useState("");
  const onDeleteConfirmClick = () => {
    setIsModalOpen(false);
  };
  const handleClose = () => {
    setClearField(true);
    setIsModalOpen(false);
  };
  const clearUploadFile = () => {
    if (
      clearField === false &&
      get(
        state,
        "api.fileuploadData.mappingConfiguration.targetUploadedFileName",
        null
      )
    ) {
      dispatch(
        setOldFileName({
          fileName: previousFile,
        })
      );
    }
  };
  const editable = get(data, "step") >= 3;
  const targetFields = [
    {
      label: "Upload File",
      value: 1,
    },
    {
      label: "Create New",
      value: 2,
    },
  ];
  const getExtensions = (x) => {
    let extensions;
    switch (x) {
      case 1:
        extensions = ".csv";
        break;
      case 2:
        extensions = " .txt, .yaml";
        break;
      case 3:
        extensions = ".xlsx, .xls";
        break;
    }
    return extensions;
  };
  useDeepEffect(() => {
    if (!isEmpty(data)) setRequireFTP(!isEmpty(ftpDetails));
  }, [data]);

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];
  useDeepEffect(() => {
    if (!isEmpty(fileNameFromApi) && !isEmpty(newFile)) {
      setIsModalOpen(true);
    }
  }, [newFile]);
  useDeepEffect(() => {
    if (!isEmpty(fileNameFromApi) && !isEmpty(newFile)) {
      setShowFileName(false);
    }
  }, [newFile]);
  const ValidationSchema = Yup.object().shape({
    fileType: Yup.number().required("Required").nullable(),
    fileName: Yup.string().when("configureOption ", {
      is: (value) => [1, 2].includes(value),
      then: Yup.string()
        .max(150, "Maximum character length should not be greater than 150")
        .required("Required"),
    }),
    format: Yup.number().min(1, "Required").required("Required"),

    delimiter: Yup.string().when("format", {
      is: 1,
      then: Yup.string().required("Required"),
    }),
    contentStartsFrom: Yup.string().required("Required"),
    recordLength: Yup.number().when("format", {
      is: 2,
      then: Yup.number().required("Required"),
    }),
    requireFtp: Yup.string().required("Required").nullable(),
  });

  const initialValues = {
    [fields.configureOption]: 1,
  };
  function onSavePassthroughTargetFunction(payload) {
    onSavePassthroughTarget(payload).then((res) => {
      setDataLoading(false);
      if (mapType == 3) {
        const outputTemplateMaps = !isEmpty(res["outputProfile"])
          ? JSON.parse(res["outputProfile"])["OutputTemplateMaps"]
          : [];
        res = { ...res, outputTemplateMaps };
      }
      if (!isEmpty(res)) {
        dispatch(
          setFileUploadData({
            mappingConfiguration: res,
          })
        );
        dispatch(setMapperPostResponse(res));
        dispatch(
          setManageMapperToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
        history.push(
          `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM}/${mapType}/${profileId}`
        );
      } else {
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      }
    });
  }
  const deserialiseSftp = !isEmpty(get(data, "outputProfile", ""))
    ? JSON.parse(get(data, "outputProfile", ""))
    : null;
  function onSubmit(values) {
    setCheckSubmit1(false);
    setCheckSubmit(false);
    if (
      ((values[fields.configureOption] == 3 && values?.fileName.length > 0) || (values[fields.configureOption] != 3))
      && (( mapType != 2) || (!values[fields.hasDefaultHeader]) || (values[fields.hasDefaultHeader] && values?.defaultHeaderName.length > 0))
    ) {
      if (parseInt(state.mapType) == 3) {
        const sftpDetails = {
          Type: deserialiseSftp?.Type,
          OutputTemplateMaps: deserialiseSftp?.OutputTemplateMaps,
          Delimiter: deserialiseSftp?.Delimiter,
          SFTPHost: values.requireFtp ? values.ftpUrl : null,
          SFTPUserName: values.requireFtp ? values.username : null,
          Authentication : values.requireFtp ? values.authentication : null,
          SSHKey : (values.requireFtp && values.authentication == 1)? values.sshKey : null,
          SFTPPassword: (values.requireFtp && values.authentication == 0) ? values.password : null,
          SFTPPath: values.requireFtp ? values.ftpPath : null,
        };
        const stringifySftpDetails = !isEmpty(sftpDetails)
          ? JSON.stringify(sftpDetails)
          : "";
        const payload = {
          id: parseInt(profileId),
          targetFileFormat: values.format,
          targetFileName:
            values.configureOption == 1
              ? `'${values.fileName}'`
              : values.configureOption == 2
              ? `@${values.fileName}`
              : values.fileName,
          targetFileHasHeader: values.hasHeader,
          targetFileContentStartsFromRow: values.contentStartsFrom,
          targetFileDelimiter: values.delimiter,
          targetFileRecordLength: values.recordLength,
          targetField: values.targetFields,
          publicKey: values.key,
          hasEncryption: values.hasEncryption,
          outputProfile: stringifySftpDetails,
          targetUploadedFileName: !isNullOrUndefined(values?.uploadTargetFields)
            ? values?.uploadTargetFields[0]?.name
            : data?.targetUploadedFileName,
          // isSFTPDetails: values.requireFtp,
          // redirectFTP: values.requireFtp
          //   ? {
          //       sFTPHost: values.ftpUrl,
          //       sFTPPath: values.ftpPath,
          //       sFTPUserName: values.username,
          //       sFTPPassword: values.password,
          //     }
          //   : null,
        };
        const configure =
          values.format === 1 || values.format === 14
            ? {
                delimiter: values.delimiter,
                commentCharacter: "#",
                headerRow: values.contentStartsFrom,
                hasHeader: true,
                allowNull: true,
              }
            : values.format === 3
            ? {
                spreadSheetToRead: 1,
                spreadSheetName: "",
                headerRow: values.contentStartsFrom,
                hasHeader: true,
                allowNull: true,
                spreadSheetNumber: 1,
              }
            : {
                recordLength: values.recordLength,
              };
        if (values.targetFields == 1) {
          if (!isEmpty(values.uploadTargetFields)) {
            setDataLoading(true);
            UploadTargetFile(values, profileId, configure).then((response) => {
              if (response.isSuccess) {
                onSavePassthroughTargetFunction(payload);
              } else {
                setDataLoading(false);
                setFileUploadRequired(response.errormessage);
              }
            });
          } else if (
            isEmpty(data?.targetUploadedFileName) &&
            isEmpty(values.uploadTargetFields)
          ) {
            setFileUploadRequired(
              "Required . Please upload a file in order to create a profile."
            );
          } else {
            onSavePassthroughTargetFunction(payload);
          }
        } else if (values.targetFields == 2) {
          onSavePassthroughTargetFunction(payload);
        }
      } else {
        if(mapType == 2 && values.requireFtp && values.authentication == 1 && values.sshKey == null){
          setFileUploadRequired("*Please upload a file.");
          return;
        }
        const fileNameValue = values[fields.fileName];
        const payload = {
          id: parseInt(profileId),
          sourceType: values.fileType,
          fileName:
            values[fields.configureOption] == 1
              ? `'${values.fileName}'`
              : values[fields.configureOption] == 2
              ? `@${fileNameValue}`
              : values.fileName,
          format: values.format,
          delimiter: values.format == 1 ? values[fields.delimiter] : null,
          contentStartsFromRow:
            values.format == 1 || values.format == 3
              ? values[fields.contentStartsFrom]
              : null,
          hasHeader:
            values.format == 1 || values.format == 3
              ? values[fields.hasHeader]
              : false,
          hasDefaultHeader : values.format == 1 ? values.hasDefaultHeader : false,
          defaultHeaderName : values.format == 1 ? values.defaultHeaderName : null,
          recordLength: values.format == 2 ? values[fields.recordLength] : null,
          publicKey: values[fields.key],
          hasEncryption: values.hasEncryption,
          ftpChannel: values.requireFtp
            ? {
                channelType: 0,
                url: values.ftpUrl,
                filePath: values.ftpPath,
                authentication : values.authentication,
                sshKey : values.authentication == 1 ? values.sshKey : null,
                userName: values.username,
                password:  values.authentication == 0 ? values.password : null ,
              }
            : null,
        };
        onSaveOutputTarget(payload)
          .then((res) => {
            setDataLoading(false);
            if (!isEmpty(res)) {
              dispatch(setMapperPostResponse(res));
              dispatch(
                setManageMapperToastInfo({
                  showToast: true,
                  toastMessage: "Data saved successfully",
                })
              );
              history.push(
                `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM_OUTPUT}/${mapType}/${profileId}`
              );
            } else {
              dispatch({
                type: MANAGE_MAPPER_POST_API_ERROR,
                payload: "Something went wrong! please try again.",
              });
            }
          })
          .catch((err) => {
            setDataLoading(false);
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! please try again.",
            });
          });
      }
    }
  }

  return (
    <Formik
      initialValues={{
        ...initialValues,
        [fields.fileType]: get(data, "sourceType") || 1,
        [fields.fileName]: fileNameFromApiRes,
        [fields.defaultHeaderName] : DefaultNameFromApiRes,
        [fields.configureOption]: fileOption,
        [fields.fileFormat]:
          mapType == 3
            ? get(data, "targetFileFormat") || 3
            : get(data, "format") || 3,
        [fields.hasHeader]:
          mapType == 3
            ? get(data, "targetFileHasHeader") ?? true
            : get(data, "hasHeader", "") ?? true,
        [fields.hasDefaultHeader]:
        mapType == 3
          ? get(data, "targetFileHasDefaultHeader") ?? false
          : get(data, "hasDefaultHeader", "") ?? false,
        [fields.contentStartsFrom]:
          mapType == 3
            ? get(data, "targetFileContentStartsFromRow") || 1
            : get(data, "contentStartsFromRow") || 1,
        [fields.delimiter]:
          mapType == 3
            ? get(data, "targetFileDelimiter") || ","
            : get(data, "delimiter") || ",",
        [fields.hasEncryption]: get(data, "hasEncryption", "") ?? false,
        [fields.key]: get(data, fields.key),
        [fields.ftpUrl]:
          mapType == 3
            ? get(deserialiseSftp, "SFTPHost", null)
            : get(ftpDetails, "url"),
        [fields.ftpPath]:
          mapType == 3
            ? get(deserialiseSftp, "SFTPPath", null)
            : get(ftpDetails, "filePath"),
        [fields.username]:
          mapType == 3
            ? get(deserialiseSftp, "SFTPUserName", null)
            : get(ftpDetails, "userName"),
        [fields.authentication]:
          mapType == 3 
            ? get(deserialiseSftp, "Authentication", null) ?? 0
            : get(ftpDetails, "authentication") ?? 0,
        [fields.sshKey]:
          mapType == 3 
            ? get(deserialiseSftp, "SSHKey", null)
            : get(ftpDetails, "sshKey"),
        [fields.password]:
          mapType == 3
            ? get(deserialiseSftp, "SFTPPassword", null)
            : get(ftpDetails, "password"),
        [fields.recordLength]:
          mapType == 3
            ? get(data, "targetFileRecordLength") || ""
            : get(data, "recordLength") || "",
        [fields.requireFtp]:
          mapType == 3
            ? !isEmpty(deserialiseSftp?.SFTPHost)
              ? true
              : false
            : !isEmpty(data.ftpChannel),
        [fields.targetFields]: get(data, "targetField") || 1,
      }}
      enableReinitialize
      onSubmit={onSubmit}
      validationSchema={ValidationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        errors,
        values,
        touched,
        setFieldValue,
        setValues,
        handleChange,
        handleSubmit,
      }) => {
        const clearFiles = () => {
          setFieldValue(fields.uploadSourceFile, undefined);
          setNewFile([]);
        };
        return (
          <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
            <LoaderWrapper isLoading={dataLoading}>
              <ManageMapperLayout layoutHeader="Target" buttons={buttons}>
                <div>
                  <div
                    style={{
                      display: "block",
                      // font: "Poppins",
                      fontSize: "18px",
                      fontWeight: "500",
                      alignItems: "center",
                      paddingBottom: "0",
                    }}
                  >
                    {mapType != 3 && (
                      <div style={{ display: "flex" }}>
                        <Field
                          name={fields.fileType}
                          label={"Type"}
                          value={values[fields.fileType]}
                          options={sourceTypeData}
                          isRequired
                          direction={"bottom"}
                          disabled={
                            isEdit || !isEmpty(get(state, formName, []))
                          }
                          popupContent={
                            <SearchableList
                              label={"Target Type"}
                              isNotTypeAhead
                              options={sourceTypeData}
                              onSelect={(value) =>
                                setFieldValue(fields.fileType, value)
                              }
                              selectedValue={values[fields.fileType]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "block",
                      // font: "Poppins",
                      fontSize: "18px",
                      fontWeight: "500",
                      alignItems: "center",
                      paddingBottom: "0",
                    }}
                  >
                    <div
                      style={{
                        paddingBottom: "0.5rem",
                        color: "#494F5A",
                        fontSize: "18px",
                        fontWeight: "550",
                      }}
                    >
                      File Information
                    </div>
                    <div>
                      {state.mapType != 3 && (
                        <div className="ft-12 fw-500 mb-2"></div>
                      )}

                      <Field
                        isRequired
                        name={fields.configureOption}
                        label="File Name Header"
                        size="sm"
                        options={fileNameOptions}
                        onChange={(value) => {
                          if (values[fields.configureOption] != value) {
                            setFieldValue(fields.configureOption, value);
                            setFieldValue(fields.fileName, "");
                          }
                          if (value == 3) setSlideShow(true);
                        }}
                        selectedValue={values[fields.configureOption]}
                        component={FieldButtonGroup}
                      />
                      {values[fields.configureOption] == 1 && (
                        <Field
                          name={fields.fileName}
                          label={"File Name"}
                          noLabelTransform
                          value={values[fields.fileName]}
                          component={FieldInput}
                          //validate={required}
                          isRequired
                        />
                      )}

                      {values[fields.configureOption] == 2 && (
                        <Field
                          name={fields.fileName}
                          label={"File Name"}
                          noLabelTransform
                          value={
                            targetFileMetaData.find(
                              (x) => x.propertyName == values[fields.fileName]
                            )?.displayName
                          }
                          options={targetFileMetaData}
                          isRequired
                          direction={"bottom"}
                          popupContent={
                            <SearchableList
                              className="fontSizeChange"
                              isNotTypeAhead
                              options={targetFileMetaData.map((item) => {
                                return {
                                  label: item?.displayName,
                                  value: item?.id,
                                };
                              })}
                              onSelect={(value, label) => {
                                setFieldValue(
                                  fields.fileName,
                                  targetFileMetaData.find((x) => x.id == value)
                                    ?.propertyName
                                );
                              }}
                              selectedValue={
                                targetFileMetaData.find(
                                  (x) =>
                                    x.propertyName == values[fields.fileName]
                                )?.datum
                              }
                              value={
                                targetFileMetaData.find(
                                  (x) =>
                                    x.propertyName == values[fields.fileName]
                                )?.displayName
                              }
                            />
                          }
                          component={FieldDropSide}
                        />
                      )}

                      {values[fields.configureOption] == 3 && (
                        <ConfigureFileSlider
                          configureValue={configureValue}
                          setConfigureValue={setConfigureValue}
                          slideShow={slideShow}
                          setSlideShow={setSlideShow}
                          dataModel={4}
                          handleChange={handleChange}
                          saveData={saveData}
                          setSaveData={setSaveData}
                          mappedData={mappedData}
                          fileName={values[fields.fileName]}
                          setFieldValuesParent={setFieldValue}
                          setMappedData={setMappedData}
                          setCheckSubmit={setCheckSubmit}
                          isDefaultHeader = {false}
                        />
                      )}

                      {values[fields.configureOption] == 3 && (
                        <div>
                          {" "}
                          <div className="file-name-header">File Name</div>
                          <div
                            className={`${
                              values?.fileName?.length >= 150 && !checkSubmit
                                ? "errorTargetCustomBox"
                                : "targetCustomBox"
                            } mt-20`}
                          >
                            <div
                              style={{
                                width: "80%",
                              }}
                            >
                              <div className="targetSelectedCustomData">
                                <AddToolTip name={values.fileName} />
                              </div>
                              {/* {values?.fileName?.length > 40 ? (
                                <div className="targetSelectedCustomData">
                                  {`${values.fileName.slice(0, 40)}...`}
                                </div>
                              ) : (
                                <div className="targetSelectedCustomData">
                                  {values.fileName}
                                </div>
                              )} */}
                            </div>

                            <div className="customEdit-align">
                              <FontAwesomeIcon
                                className="customEdit"
                                icon={faEdit}
                                onClick={(evt) => {
                                  evt.stopPropagation();
                                  setSlideShow(true);
                                }}
                              ></FontAwesomeIcon>
                            </div>
                          </div>
                          {!values?.fileName && !checkSubmit && (
                            <div className="mapperErrorMessage">Required</div>
                          )}
                          {values?.fileName?.length >= 150 && !checkSubmit && (
                            <div className="mapperErrorMessage">
                              Maximum character length should not be greater
                              than 150
                            </div>
                          )}
                        </div>
                      )}

                      <Field
                        name={fields.fileFormat}
                        label={"File format"}
                        value={values[fields.fileFormat]}
                        options={
                          mapType == 3
                            ? PassthorughTargetfileFormatData
                            : fileFormatData
                        }
                        isRequired
                        direction={"bottom"}
                        popupContent={
                          <SearchableList
                            label={"File Format"}
                            isNotTypeAhead
                            options={
                              mapType == 3
                                ? PassthorughTargetfileFormatData
                                : fileFormatData
                            }
                            onSelect={(value) =>{
                              if(values[fields.fileFormat] != value){
                                setFieldValue(fields.hasDefaultHeader, false);  // setting hasDefaultHeader to false
                              }
                              setFieldValue(fields.fileFormat, value);
                            }
                          }
                            selectedValue={values[fields.fileFormat]}
                          />
                        }
                        component={FieldDropSide}
                      />

                      {values?.format == 1 && (
                        <Field
                          name={fields.delimiter}
                          label={"Delimiter"}
                          value={values[fields.delimiter]}
                          noLabelTransform
                          component={FieldInput}
                          validate={(value) => {
                            return [undefined, null, ""].includes(value.trim())
                              ? "Required"
                              : undefined;
                          }}
                          isRequired
                        />
                      )}
                      {(values?.format == 1 || values?.format == 3) && (
                        <>
                          <Field
                            isRequired
                            name={fields.hasHeader}
                            label="Has Header"
                            size="sm"
                            options={yesNoOptions}
                            // selectedValue={returnOnlyIfBoolean(
                            //   values[fields.hasHeader]
                            // )}
                            onChange={(value) => {
                              if (value) {
                                setFieldValue(fields.targetFields, 1);
                              } else {
                                setFieldValue(fields.targetFields, 2);
                              }

                              setFieldValue(fields.hasHeader, value);
                            }}
                            selectedValue={values[fields.hasHeader]}
                            component={FieldButtonGroup}
                          />
                          <Field
                            type="number"
                            name={fields.contentStartsFrom}
                            label={"Content Starts From (Row)"}
                            placeholder={"Content Starts From"}
                            noLabelTransform
                            value={values[fields.contentStartsFrom]}
                            component={FieldInput}
                            validate={(value) => {
                              if ([undefined, null, ""].includes(value)) {
                                return "Required";
                              } else if (
                                iscontentstartsfrom.test(value) === false
                              ) {
                                return "Content Starts From should not be greater than 7 digits";
                              } else if (value <= 0) {
                                return "Content Starts From (Row) should be greater than 0";
                              } else {
                                return undefined; // Validation passed
                              }
                            }}
                            isRequired
                            // onInput={(e) => {
                            //   const inputValue = e.target.value.toString();
                            //   if (inputValue.length > 7) {
                            //     e.target.value = inputValue.slice(0, 7);
                            //   }
                            // }}
                            onKeyPress={(e) => {
                              // Prevent the input of decimal point
                              if (
                                e.key === "." ||
                                (e.key === "-" && e.target.value !== "")
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(e) => {
                              const pastedData = e.clipboardData.getData(
                                "text/plain"
                              );
                              if (
                                pastedData.includes("e") ||
                                pastedData.includes(".") ||
                                pastedData.includes("-")
                              ) {
                                e.preventDefault(); // Prevent the paste action if it exceeds 250 characters
                              }
                            }}
                          />
                        </>
                      )}
                     {values[fields.fileFormat] == 1 && values[fields.hasHeader] == 1 && ( //if CSV and hasHeader is true
                        <Field
                          isRequired
                          name={fields.hasDefaultHeader}
                          label="Has Default Header"
                          size="sm"
                          options={yesNoOptions}
                          onChange={(value) => {
                            if (value) {
                              setFieldValue(fields.targetFields, 1);
                            } else {
                              setFieldValue(fields.targetFields, 2);
                            }

                            setFieldValue(fields.hasDefaultHeader, value);
                          }}
                          selectedValue={values[fields.hasDefaultHeader]}
                          component={FieldButtonGroup}
                        />
                      )}
                      {values[fields.fileFormat] == 1 && values[fields.hasDefaultHeader] == 1 && (
                          <ConfigureFileSlider
                            configureValue={configureValue1}
                            setConfigureValue={setConfigureValue1}
                            slideShow={slideShow1}
                            setSlideShow={setSlideShow1}
                            dataModel={4}
                            handleChange={handleChange}
                            saveData={saveData1}
                            setSaveData={setSaveData1}
                            mappedData={mappedData1}
                            fileName={values[fields.defaultHeaderName]}
                            setFieldValuesParent={setFieldValue}
                            setMappedData={setMappedData1}
                            setCheckSubmit={setCheckSubmit1}
                            isDefaultHeader = {true}
                          />
                      )}
                      {values[fields.fileFormat] == 1 && values[fields.hasDefaultHeader] == 1 && (
                        <div>
                            {" "}
                            <div className="file-name-header">Default Header Name</div>
                            <div
                              className={`${
                                values?.defaultHeaderName?.length >= 150 && !checkSubmit1
                                  ? "errorTargetCustomBox"
                                  : "targetCustomBox"
                              } mt-20`}
                            >
                              <div
                                style={{
                                  width: "80%",
                                }}
                              >
                                <div className="targetSelectedCustomData">
                                  <AddToolTip name={values.defaultHeaderName} />
                                </div>
                              </div>

                              <div className="customEdit-align">
                                <FontAwesomeIcon
                                  className="customEdit"
                                  icon={faEdit}
                                  onClick={(evt) => {
                                    evt.stopPropagation();
                                    setSlideShow1(true);
                                  }}
                                ></FontAwesomeIcon>
                              </div>
                            </div>
                            {!values?.defaultHeaderName && !checkSubmit1 && (
                              <div className="mapperErrorMessage">Required</div>
                            )}
                            {values?.defaultHeaderName?.length >= 150 && !checkSubmit1 && (
                              <div className="mapperErrorMessage">
                                Maximum character length should not be greater
                                than 150
                              </div>
                            )}
                          </div>
                      )}

                      {values?.format == 2 && (
                        <Field
                          name={fields.recordLength}
                          label={"Record Length"}
                          noLabelTransform
                          type="number"
                          value={values[fields.recordLength]}
                          min={1}
                          max={999999999}
                          component={FieldInputNumber}
                          onChange={handleChange}
                          validate={(value) => {
                            var result = required(value);
                            if (!result) {
                              var toValues = data?.fixedWidthOutputSections?.map(
                                (item) => {
                                  return Math.max(
                                    ...item?.fixedWidthOutputSectionFields?.map(
                                      (x) => x?.to
                                    )
                                  );
                                }
                              );
                              var maxValue = Math.max(...toValues);
                              if (value < maxValue)
                                return "Record Length should be greater than or equal to the maximum index of the fields";
                              else return undefined;
                            } else {
                              return result;
                            }
                          }}
                          isRequired
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="target-source-length"
                    style={{
                      display: "block",
                      // font: "Poppins",
                      fontSize: "18px",
                      fontWeight: "500",
                      alignItems: "center",
                      paddingBottom: "0",
                    }}
                  >
                    {/* <EncryptionDetails
                      setFieldValue={setFieldValue}
                      required={required}
                      fields={fields}
                      values={values}
                    /> */}
                    <Field
                      isRequired
                      name={fields.requireFtp}
                      label="FTP Details"
                      size="sm"
                      options={yesNoOptions}
                      onChange={(value) => {
                        setFieldValue(fields.requireFtp, value);
                      }}
                      selectedValue={values[fields.requireFtp]}
                      component={FieldButtonGroup}
                    />

                    <FTPDetails
                      showFtpDetails={values[fields.requireFtp]}
                      required={required}
                      fields={fields}
                      values={values}
                      setValue = {setFieldValue}
                      fileUploadRequired = {fileUploadRequired}
                      setFileUploadRequired = {setFileUploadRequired}
                      mapType = {mapType}
                    />

                    {mapType == 3 && (
                      <>
                        <div
                          className={values[fields.targetFields] != 1 && "pb-5"}
                        >
                          <Field
                            isRequired
                            name={fields.targetFields}
                            label="Target Fields"
                            size="sm"
                            options={targetFields}
                            onChange={(value) => {
                              setFieldValue(fields.targetFields, value);
                            }}
                            selectedValue={values[fields.targetFields]}
                            component={FieldButtonGroup}
                          />
                        </div>
                        {values[fields.targetFields] == 1 && (
                          <div style={{ width: "40rem" }}>
                            {editable ? (
                              <>
                                <div>Uploaded File</div>
                                <div>
                                  <UploadComponent
                                    page={"OnboardingFileUpload"}
                                    name={"uploadTargetFields"}
                                    values={values}
                                    clearUploadFile={clearUploadFile}
                                    setFieldValue={setFieldValue}
                                    setNewFile={setNewFile}
                                    clearField={clearField}
                                    setShowFileName={setShowFileName}
                                    setFileUploadRequired={
                                      setFileUploadRequired
                                    }
                                    setClearField={setClearField}
                                    label="Upload Target file"
                                    fileExtensions={getExtensions(
                                      values.format
                                    )}
                                  />
                                </div>
                                {showFileName ? (
                                  <div>
                                    {values.targetUploadedFileName
                                      ? values.targetUploadedFileName
                                      : get(
                                          state,
                                          "api.data.targetUploadedFileName",
                                          []
                                        )}
                                  </div>
                                ) : null}
                                <span
                                  style={{ fontSize: "12px", color: "red" }}
                                >
                                  {fileUploadRequired}
                                </span>
                              </>
                            ) : (
                              <div style={{ width: "40rem" }}>
                                <div>
                                  <UploadComponent
                                    name={"uploadTargetFields"}
                                    setFieldValue={setFieldValue}
                                    label="Upload Target file"
                                    fileExtensions={getExtensions(
                                      values.format
                                    )}
                                  />
                                </div>
                                <div
                                  style={{
                                    fontSize: "0.75rem",
                                    marginTop: "0rem",
                                    color: "#ff5050",
                                  }}
                                >
                                  <span
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    {fileUploadRequired}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}

                    {/* {values[fields.requireFtp] && (
                      <div style={{ width: "20rem", paddingTop: "0.5rem" }}>
                        <Field
                          name={fields.ftpUrl}
                          placeholder={"eg : ftp://yourname@host.dom/"}
                          label={"FTP URL"}
                          noLabelTransform
                          value={values[fields.ftpUrl]}
                          component={FieldInput}
                          isRequired
                          validate={values.requireFtp && required}
                        />
                        <Field
                          name={fields.ftpPath}
                          placeholder={"eg : ftp.yourname@host.dom/batchfile"}
                          label={"FTP path"}
                          noLabelTransform
                          value={values[fields.ftpPath]}
                          component={FieldInput}
                          isRequired
                          validate={values.requireFtp && required}
                        />
                        <Field
                          name={fields.username}
                          placeholder={"Enter UserName"}
                          label={"UserName"}
                          noLabelTransform
                          value={values[fields.username]}
                          component={FieldInput}
                          isRequired
                          validate={values.requireFtp && required}
                        />
                        <Field
                          name={fields.password}
                          placeholder={"Enter Password"}
                          label={"Password"}
                          noLabelTransform
                          value={values[fields.password]}
                          component={FieldInputPassword}
                          isRequired
                          validate={values.requireFtp && required}
                        />
                      </div>
                    )} */}
                  </div>
                </div>
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={() => setIsModalOpen(false)}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <h4>New File Detected </h4>
                        <p>
                          Are you sure ? Some of your mapped fields will be
                          deleted.. Do you want to continue ?
                        </p>

                        <Button
                          className="remove-btn mr-4"
                          onClick={onDeleteConfirmClick}
                        >
                          Yes
                        </Button>
                        <Button
                          className="cancel-btn"
                          onClick={() => {
                            handleClose();
                            clearFiles();
                          }}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManageMapperLayout>
            </LoaderWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default OutputTargetContainer;
